<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="20.493" height="10" viewBox="0 0 20.493 10">
        <g id="Icon-Drag" transform="translate(0 0.5)">
            <line id="Line_15" data-name="Line 15" x2="20.493" transform="translate(0 9)" fill="none" :stroke="this.$vuetify.theme.dark ? '#CECECE' : '#707070'" stroke-width="1"/>
            <line id="Line_17" data-name="Line 17" x2="20.493" fill="none" :stroke="this.$vuetify.theme.dark ? '#CECECE' : '#707070'"  stroke-width="1"/>
        </g>
    </svg>
</template>

<script>
export default {
  name: 'DragIcon'
}
</script>

<style scoped>
    svg {
        width: 20.493px;
        height: 10px;
    }
</style>